import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { PointModel } from '@/core/Point/model/PointModel.js';

/**
 * @method apiGetPointHistory
 * @method apiExpirePoint
 */
export default {
    config: function () {
        return Vue.bzbsConfig;
    },

    /**
     * @param {String} token
     * @param {Object} params HistoryPointConfigModel - /service/config/PointConfigModel.js
     */
    apiGetPointHistory: function(token, listConfig) {
        var params = listConfig.getParams();
        var url = this.config().bzbsUrl + "/log/points";

        return BzbsApi.connectBzbsGet(url, token, params).pipe(map(res => {
            let list = [];
            for (let i of res.data) {
                let point = new PointModel(i);
                list.push(point);
            }

            return list;
        }));
    },

    /**
     * @param {string} token
     */
    apiExpirePoint: function(token) {
        var url = this.config().bzbsUrl + "/log/points";
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map(res => res.data));
    },
}
